// The published header's soft shadow, from shared-assets site-nav/core/values.js.
const SOFT_SHADOW = '0 4px 20px color-mix(in srgb, var(--startup-text-color) 15%, transparent)';
const COLORS = [['textColor', 'color'], ['backgroundColor', 'background-color'], ['borderColor', 'border-color']];

// The bar as the published page paints it before or after scrolling: an empty color after scrolling
// keeps the one before; shadow and blur belong to each state.
function readDeclarations(value, scrolled) {
  let appearance = value.initial;
  if (scrolled === true) {
    appearance = value.scrolled;
  }
  const declarations = [];
  for (const [field, property] of COLORS) {
    const color = appearance[field] || value.initial[field];
    if (color !== null) {
      declarations.push(property + ':' + color);
    }
  }
  if (appearance.blur > 0) {
    declarations.push('backdrop-filter:blur(' + appearance.blur + 'px)');
  }
  if (appearance.shadow === true) {
    declarations.push('box-shadow:' + SOFT_SHADOW);
  }
  return declarations;
}

// In the editor the block's own padding, colors and border sit on its editor element, so the bar's
// appearance goes there too and covers the whole bar.
export function appearanceRules(value, scrolled, id) {
  const declarations = readDeclarations(value, scrolled);
  if (declarations.length === 0 || typeof id !== 'string') {
    return '';
  }
  return '.site-nav-node.editor-node-main[data-node-id=' + JSON.stringify(id) + '] > .editor-element{' + declarations.join(';') + '}';
}
